/**
 * Data no formato `AAAA-MM-DD`, no fuso de QUEM ESTÁ OLHANDO.
 *
 * Existe porque `date.toISOString().split('T')[0]` — que era o jeito usado —
 * converte para UTC antes de cortar. O Brasil é UTC−3, então das 21h em
 * diante o "hoje" do usuário vira o dia seguinte:
 *
 *   new Date()          // 31/08/2026 21:51, horário de Brasília
 *   .toISOString()      // "2026-09-01T00:51:00.000Z"
 *   .split('T')[0]      // "2026-09-01"  <-- amanhã
 *
 * O sintoma era o filtro de histórico: escolher "Hoje" depois das 21h não
 * trazia nada, embora os atendimentos estivessem lá. E era silencioso — a
 * tela dizia "Nenhum dado encontrado", que é indistinguível de não haver
 * atendimento nenhum.
 *
 * Datas escolhidas no calendário não sofriam disso, porque nascem à
 * meia-noite local e sobrevivem à conversão. Por isso "de ontem até hoje"
 * funcionava e "hoje" não — o que tornava o bug ainda mais confuso.
 *
 * @param {Date} date
 * @returns {string} ex.: "2026-08-31"
 */
export const dataLocal = (date) => {
  const d = date instanceof Date ? date : new Date(date);

  if (Number.isNaN(d.getTime())) return '';

  const ano = d.getFullYear();
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const dia = String(d.getDate()).padStart(2, '0');

  return `${ano}-${mes}-${dia}`;
};

export default dataLocal;
